module.exports = __webpack_public_path__ + "static/media/truck_red_temp_blue.362124c2.png";